import React, {PureComponent, ReactNode} from 'react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {fixed2int} from 'app/utils/fixed';

interface DigitalPrizeImageProps {
    amount: number | string;
    prefix?: string;
    measure?: string;
    variant?: 'frozen';
}

const FROZEN_ICON_SIZE = 18;

export default class DigitalPrizeImage extends PureComponent<DigitalPrizeImageProps> {
    get amount(): string {
        const {prefix = '', amount} = this.props;
        return `${prefix}${fixed2int(amount)}`;
    }

    get title(): string {
        const {measure} = this.props;
        return `${this.amount} ${measure || ''}`.trim();
    }

    render(): ReactNode {
        const {measure, variant} = this.props;
        const isFrozen = variant === 'frozen';
        const previewClass = isFrozen ? 'bonus-preview bonus-preview--frozen' : 'bonus-preview';

        return <div className="hero__slot--img">
            <div className={previewClass} title={this.title}>
                <div className="bonus-preview__stroke">
                    <SpriteIcon name="#svg-bonus-stroke" size={{height: 147, width: 147}} />
                </div>
                <div className="bonus-preview__wrap">
                    <div className="bonus-preview__stars bonus-preview__stars--top">
                        <SpriteIcon name="#svg-bonus" size={{height: 16, width: 45}} />
                    </div>
                    <div className="bonus-preview__text">
                        <span className="bonus-preview__amount">
                            {isFrozen && <SpriteIcon
                                name="#svg-balance-frozen"
                                className="bonus-preview__frozen-icon"
                                size={{height: FROZEN_ICON_SIZE, width: FROZEN_ICON_SIZE}}
                            />}
                            {this.amount}
                        </span>
                        {measure && <span className="bonus-preview__measure">{measure}</span>}
                    </div>
                    <div className="bonus-preview__stars bonus-preview__stars--bottom">
                        <SpriteIcon name="#svg-bonus" size={{height: 16, width: 45}} />
                    </div>
                </div>
            </div>
        </div>;
    }
}
